<template>
  <div>
    <div class="dashboard-payment-deviation-summary">
      <DashboardPieChart
        v-if="countSeriesPresent"
        :value="countSeries"
        label="Fakturavolum"
        :options="chartOptionsCount"
        :height="225"
      />
      <DashboardPieChart
        v-if="moneySeriesPresent"
        :value="moneySeries"
        label="Fakturaverdi"
        :options="chartOptionsMoney"
        :height="225"
      />
    </div>
    <div class="legends mt-4">
      <div v-for="(item, index) in labels" :key="index" class="d-flex items-center">
        <div class="legends__box" :style="`background: ${item.color}`" />
        <span class="ml-1">{{ item.label }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
      <button class="btn btn-sm btn-outline-secondary" @click="goToCustomerList">Til rapport</button>
    </div>
  </div>
</template>

<script>
import DashboardPieChart from '@/components/reports/dashboard/DashboardPieChart';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardPaymentDeviationSummary',
  components: {
    DashboardPieChart,
  },
  computed: {
    ...mapGetters('reports', ['getDashboardPaymentDeviationTotals']),

    dataIn() {
      return this.getDashboardPaymentDeviationTotals;
    },
    labels() {
      return [
        {
          label: 'Ubetalt <15 dager',
          color: 'var(--warning)',
        },
        {
          label: 'Ubetalt >15 dager',
          color: 'var(--color-warning)',
        },
        {
          label: 'Ubetalt >30 dager',
          color: '#B60303',
        },
      ];
    },
    countSeriesPresent() {
      return this.dataIn && this.dataIn.count
        ? this.dataIn.count.from1To15 > 0 || this.dataIn.count.from16To30 > 0 || this.dataIn.count.from30 > 0
        : false;
    },
    countSeries() {
      if (this.moneySeriesPresent) {
        return [
          { label: 'Ubetalt <15 dager', value: this.dataIn.count.from1To15, color: 'var(--warning)' },
          { label: 'Ubetalt >15 dager', value: this.dataIn.count.from16To30, color: 'var(--color-warning)' },
          { label: 'Ubetalt >30 dager', value: this.dataIn.count.from30, color: '#B60303' },
        ];
      }
      return null;
    },
    moneySeriesPresent() {
      return this.dataIn && this.dataIn.money
        ? this.dataIn.money.from1To15 > 0 || this.dataIn.money.from16To30 > 0 || this.dataIn.money.from30 > 0
        : false;
    },
    moneySeries() {
      if (this.moneySeriesPresent) {
        return [
          { label: 'Ubetalt <15 dager', value: this.dataIn.money.from1To15, color: 'var(--warning)' },
          { label: 'Ubetalt >15 dager', value: this.dataIn.money.from16To30, color: 'var(--color-warning)' },
          { label: 'Ubetalt >30 dager', value: this.dataIn.money.from30, color: '#B60303' },
        ];
      }
      return null;
    },
    chartOptionsCount() {
      return {
        labels: this.countSeries.map(x => x.label),
        chart: {
          animations: {
            enabled: false,
          },
          type: 'pie',
        },
        dataLabels: {
          formatter: this.countFormatter,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: this.countSeries.map(value => value.color),
      };
    },
    chartOptionsMoney() {
      return {
        labels: this.moneySeries.map(x => x.label),
        chart: {
          animations: {
            enabled: false,
          },
          type: 'pie',
        },
        dataLabels: {
          formatter: this.moneyFormatter,
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: this.moneySeries.map(value => value.color),
      };
    },
  },

  methods: {
    countFormatter(value, { seriesIndex, w }) {
      return w.config.series[seriesIndex];
    },
    moneyFormatter(value, { seriesIndex, w }) {
      return this.$options.filters.toCurrency(w.config.series[seriesIndex]);
    },
    goToCustomerList() {
      this.$router.push({
        name: 'reports_customer_list',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-payment-deviation-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.legends {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(115px, 1fr));
  justify-items: center;
  gap: 1rem 1rem;
  padding: 0rem 2rem;
}
.legends div {
  align-items: center;
}
.legends__box {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}
.legends div span {
  font-size: 12px;
}
</style>
